export enum UserRole {
    ROLE_SW_ADMIN = 'ROLE_SW_ADMIN',
    ROLE_INSTRUCTOR = 'ROLE_INSTRUCTOR',
    ROLE_STUDENT = 'ROLE_STUDENT',
}
